export default __webpack_public_path__ + "static/media/sr-marker.801afe9f.svg";